import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconOpen = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 13 14",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.848 7.908V1.543a.783.783 0 0 0-.782-.79H5.774a.786.786 0 0 0-.784.793v1.057a.786.786 0 0 0 .784.794h4.46v4.51a.786.786 0 0 0 .784.794h1.046a.787.787 0 0 0 .784-.793ZM7.311 13.51H1.02a.783.783 0 0 1-.782-.79V6.355a.786.786 0 0 1 .784-.794h1.046a.786.786 0 0 1 .784.794v4.51h4.46a.786.786 0 0 1 .784.794v1.058a.786.786 0 0 1-.784.793Z"
	})
});
export default SvgIconOpen;
